import { Plane } from "../math/Plane";
import { BoundSphere } from "../math/BoundSphere";
import { Matrix4x4 } from "../../maths/Matrix4x4";
import { Vector3 } from "../../maths/Vector3";
import { LayaGL } from "../../layagl/LayaGL";
import { BoundFrustum } from "../math/BoundFrustum";
export class CameraCullInfo {
    constructor() {
        this.boundFrustum = new BoundFrustum(new Matrix4x4());
    }
}
export class ShadowCullInfo {
}
export class ShadowSpotData {
    constructor() {
        this.position = new Vector3;
        this.viewMatrix = new Matrix4x4();
        this.projectionMatrix = new Matrix4x4();
        this.viewProjectMatrix = new Matrix4x4();
        this.cameraShaderValue = LayaGL.renderDeviceFactory.createShaderData(null);
        this.cameraCullInfo = new CameraCullInfo();
    }
    destroy() {
        this.cameraShaderValue.destroy();
        this.cameraShaderValue = null;
        this.cameraCullInfo = null;
    }
}
export class ShadowSliceData {
    constructor() {
        this.position = new Vector3();
        this.viewMatrix = new Matrix4x4();
        this.projectionMatrix = new Matrix4x4();
        this.viewProjectMatrix = new Matrix4x4();
        this.cullPlanes = [new Plane(new Vector3(), 0), new Plane(new Vector3(), 0), new Plane(new Vector3(), 0), new Plane(new Vector3(), 0), new Plane(new Vector3(), 0), new Plane(new Vector3(), 0), new Plane(new Vector3(), 0), new Plane(new Vector3(), 0), new Plane(new Vector3(), 0), new Plane(new Vector3(), 0)];
        this.splitBoundSphere = new BoundSphere(new Vector3(), 0.0);
        this.cameraShaderValue = LayaGL.renderDeviceFactory.createShaderData(null);
    }
    destroy() {
        this.cameraShaderValue.destroy();
        this.cameraShaderValue = null;
        this.cullPlanes = null;
    }
}
